import { atomWithStorage } from 'jotai/utils';
import deriveDefaultLocaleForFrontend from './deriveDefaultLocaleForFrontend';
import { atom } from 'jotai';
import { SupportedLocale } from '../constants';
import { i18n, Messages } from '@lingui/core';

export const atomLocale = atomWithStorage(
  'locale',
  deriveDefaultLocaleForFrontend(null), // Individual apps should override this with their own default locale
  /*= storage */ undefined, // default is localstorage
  { getOnInit: true }
);

const defaultLoadMessages = (_: SupportedLocale) => {
  return Promise.resolve({} as Messages);
};

let loadMessages = defaultLoadMessages;

export const atomLoadMessages = atom(
  (_) => loadMessages,
  (_, __, loader: typeof defaultLoadMessages) => {
    loadMessages = loader;
  }
);

const messagesAtom = atom((get) => get(atomLoadMessages)(get(atomLocale)));

export const atomActivatedI18n = atom(async (get) => {
  const locale = get(atomLocale);
  const messages = await get(messagesAtom);
  i18n.load(locale, messages);
  i18n.activate(locale);
  return i18n;
});
